import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&family=Open+Sans:wght@400;500;600;700&display=swap');

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    font-size: 16px;
    scroll-behavior: smooth;
  }

  body {
    font-family: ${props => props.theme.fonts.body};
    font-weight: ${props => props.theme.fontWeights.regular};
    color: ${props => props.theme.colors.dark};
    background-color: ${props => props.theme.colors.background};
    line-height: 1.6;
    overflow-x: hidden;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${props => props.theme.fonts.heading};
    font-weight: ${props => props.theme.fontWeights.bold};
    margin-bottom: ${props => props.theme.spacing.md};
    line-height: 1.2;
    color: ${props => props.theme.colors.dark};
  }

  h1 {
    font-size: ${props => props.theme.fontSizes.huge};
  }

  h2 {
    font-size: ${props => props.theme.fontSizes.xxxl};
  }

  h3 {
    font-size: ${props => props.theme.fontSizes.xxl};
  }

  h4 {
    font-size: ${props => props.theme.fontSizes.xl};
  }

  h5 {
    font-size: ${props => props.theme.fontSizes.lg};
  }

  h6 {
    font-size: ${props => props.theme.fontSizes.md};
  }

  p {
    margin-bottom: ${props => props.theme.spacing.md};
  }

  a {
    color: ${props => props.theme.colors.secondary};
    text-decoration: none;
    transition: ${props => props.theme.transitions.fast};

    &:hover {
      color: ${props => props.theme.colors.primary};
    }
  }

  img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  ul, ol {
    margin-bottom: ${props => props.theme.spacing.md};
    margin-left: ${props => props.theme.spacing.lg};
  }

  button, input, textarea, select {
    font-family: ${props => props.theme.fonts.body};
  }

  section {
    padding: ${props => props.theme.spacing.xxl} 0;
  }

  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 ${props => props.theme.spacing.md};
  }

  @media (max-width: ${props => props.theme.breakpoints.md}) {
    h1 {
      font-size: ${props => props.theme.fontSizes.xxxl};
    }

    h2 {
      font-size: ${props => props.theme.fontSizes.xxl};
    }

    h3 {
      font-size: ${props => props.theme.fontSizes.xl};
    }

    section {
      padding: ${props => props.theme.spacing.xl} 0;
    }
  }

  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    h1 {
      font-size: ${props => props.theme.fontSizes.xxl};
    }

    h2 {
      font-size: ${props => props.theme.fontSizes.xl};
    }

    h3 {
      font-size: ${props => props.theme.fontSizes.lg};
    }

    section {
      padding: ${props => props.theme.spacing.lg} 0;
    }
  }
`;

export default GlobalStyles; 